export default __webpack_public_path__ + "static/media/announcement_3@2x.d8c917ea.png";